import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootDispatch, RootState } from 'storage/store';
import { IBeforeInstallPromptEvent } from '../storage/pwa/pwa.model';
import { detectBrowser } from '../utils/detectBrowser';

const useHandlePWA = (
  prompt: IBeforeInstallPromptEvent | null,
  isLoggedIn: boolean | null | string
) => {
  const isIphone = useSelector((state: RootState) => state.pwa.isIphone);

  const dispatch = useDispatch<RootDispatch>();
  useEffect(() => {
    detectBrowser(dispatch);
  }, []);
  useEffect(() => {
    if (isIphone) {
      dispatch.pwa.setPWAButton(true);
    }
  }, [isIphone]);
  useEffect(() => {
    const isAppInstalled = async () => {
      if (prompt) {
        try {
          const userChoice = await prompt.userChoice;
          if (userChoice.outcome === 'accepted') {
            dispatch.pwa.setPWAButton(false);
          }
        } catch (error) {
          throw new Error('User declined to install');
        }
      }
    };

    isAppInstalled();
  }, [prompt]);

  useEffect(() => {
    if (prompt) {
      dispatch.pwa.setPrompt(prompt);
    }
  }, [prompt, isLoggedIn]);

  useEffect(() => {
    if (prompt !== null) {
      dispatch.pwa.setPWAButton(true);
    }
  }, [prompt]);
};

export default useHandlePWA;
